import * as React from "react";
import { forwardRef } from "react";
const SvgDeselected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeWidth: 1.5, d: "M16 .75c.916 0 1.747.334 2.339.926.57.57.911 1.375.911 2.324v12a3.24 3.24 0 0 1-.952 2.298A3.24 3.24 0 0 1 16 19.25H4a3.24 3.24 0 0 1-2.298-.952A3.24 3.24 0 0 1 .75 16V4c0-.897.364-1.71.952-2.298A3.24 3.24 0 0 1 4 .75z", transform: "translate(2 2)" }));
const ForwardRef = forwardRef(SvgDeselected);
export { ForwardRef as ReactComponent };
